import { render, staticRenderFns } from "./bo-navbar.vue?vue&type=template&id=13f2fa5a"
import script from "./bo-navbar.vue?vue&type=script&lang=js"
export * from "./bo-navbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports